import { useLayoutEffect, useState } from "react";

/**
 * Returns the current window dimensions [width, height], updating on resize.
 * Debounces resize events by 100ms.
 */
const useWindowResize = (): [number | undefined, number | undefined] => {
  const [windowSize, setWindowSize] = useState<
    [number | undefined, number | undefined]
  >([undefined, undefined]);

  useLayoutEffect(() => {
    let timer: ReturnType<typeof setTimeout>;
    const handleResize = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        setWindowSize([window.innerWidth, window.innerHeight]);
      }, 100);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      clearTimeout(timer);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return windowSize;
};

export default useWindowResize;
